import { render, staticRenderFns } from "./confirmed.vue?vue&type=template&id=bce564cc&scoped=true&"
import script from "./confirmed.vue?vue&type=script&lang=js&"
export * from "./confirmed.vue?vue&type=script&lang=js&"
import style0 from "./confirmed.vue?vue&type=style&index=0&id=bce564cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce564cc",
  null
  
)

export default component.exports